import React from 'react';
import Form from 'react-bootstrap/Form';
import * as context from './context';

export const Filter = () => {
  const [value, setValue] = React.useState('');
  const setFilter = React.useContext(context.filter)?.setFilter;
  React.useEffect(() => {
    const timeoutId = global.setTimeout(() => {
      setFilter(value);
    }, 100);
    return () => global.clearTimeout(timeoutId);
  }, [setFilter, value]);
  return (
    <>
      <Form id="table-global-search" onSubmit={(event) => event.preventDefault()} role="search" className="flex-fill rax-mgcp-project-filter">
        <Form.Control
          className="flex-fill"
          type="search"
          aria-label="Filter Projects..."
          placeholder="Filter Projects..."
          value={value || ''}
          onChange={(e) => setValue(e.target.value)}
        />
      </Form>
    </>
  );
};
